// extracted by mini-css-extract-plugin
module.exports = {"div":"ScannerOrUploadModal_div_2KrhZ"};